const ConnectFunction = 'ConnectFunction';

export { ConnectFunction };
